import React from "react";
import { Box, Container } from "@mui/material";

export default function MainContent({ children }) {
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        width: "100%",
        background: "#f8fafc",
        overflowX: "hidden",
      }}
    >
      <Container
        maxWidth="xl"
        disableGutters
        sx={{
          width: "100%",
          px: { xs: 1.25, sm: 2, md: 2.5, lg: 3 },
          py: { xs: 1.5, md: 2.5 },
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "1180px",
            background: "#fff",
            border: "1px solid rgba(15,23,42,0.08)",
            borderRadius: { xs: 2, md: 3 },
            p: { xs: 1.5, sm: 2, md: 2.5 },
            minHeight: { xs: "auto", md: "calc(100vh - 68px - 48px)" },
            boxSizing: "border-box",
            overflowX: "hidden",
            boxShadow: {
              xs: "none",
              md: "0 10px 24px rgba(15, 23, 42, 0.05)",
            },
          }}
        >
          {children}
        </Box>
      </Container>
    </Box>
  );
}